<template>
  <div class="breadcrumb" :class="{'has-multiple-levels': hasMultipleLevels}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    hasMultipleLevels: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.breadcrumb {
  @apply uppercase;
  &:not(.has-multiple-levels) {
    @apply truncate;
  }
}
</style>
